import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/sonner'
import { initTelegram } from '@/telegram'
import { initSentry } from '@/lib/sentry'
import App from './App'
import './index.css'

// Build stamp — меняется каждый build, заставляет Vite PWA плагин пересчитать
// precache manifest и обновить sw.js даже при одинаковом bundle-контенте.
// Нужно чтобы пушить server-only изменения (например CSP в nginx vhost) до
// юзеров с устаревшим SW cache — старые SW увидят новый manifest →
// skipWaiting+clientsClaim → свежая загрузка документа с актуальными
// response headers.
const BUILD_STAMP = `visual-${new Date().toISOString()}`  // ISO w/ ms — unique per-build
if (typeof window !== 'undefined') {
  (window as unknown as { __PS_BUILD__?: string }).__PS_BUILD__ = BUILD_STAMP
}

initSentry()
initTelegram()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 2 },
  },
})

try {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster position="top-center" richColors closeButton />
      </QueryClientProvider>
    </StrictMode>
  )
} catch (e) {
  ;(window as unknown as { __bootErr?: (e: unknown) => void }).__bootErr?.(e)
}
